import axios from "axios"
import { IndustriaReadingDtoProps } from "./DTOs/IndustriaReadingDto"
import { IndustriaReadingDtoAdapter } from "./Industria.adapter"

/**
 * Retrieves the IndustriaReadingDto from the server.
 * @returns A promise that resolves to an array of IndustriaReadingDtoProps.
 */
export async function GetIndustriaReadingDto(): Promise<
  Array<IndustriaReadingDtoProps>
> {
  const { data } = await axios.get("/Industria/all")
  return data?.map((industria: IndustriaReadingDtoProps) =>
    IndustriaReadingDtoAdapter(industria)
  )
}
